module.exports = __webpack_public_path__ + "static/media/icon-download-ios.018893c9.png";